const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid #1a5c2a', fontFamily:"'Georgia', serif", color:'#0a1f0e', lineHeight:'1.7', background:'#f2faf4' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #2e8b47', paddingBottom:'8px', marginBottom:'24px', color:'#145a24' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#1e7a36', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #2e8b47', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#e8f5ec', border:'2px solid #2e8b47', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#145a24', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #2e8b47' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#1e7a36', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #b6dfc0', verticalAlign:'top', background:'#edf7f0' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #b6dfc0', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#145a24', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#f4fbf6', border:'1px solid #b6dfc0', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#145a24', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#3a7a4a', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Details</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Laser Engraving Machine Anatomy ─────────────────────
function DiagramMachineAnatomy() {
  const W = 980, H = 460;
  // Three-column layout: labels left (0–205), machine centre (215–620), info panel right (635–975)
  const labelMaxX = 205;
  const mL = 218;

  const annots = [
    { dotX: mL + 68,  dotY: 52,  label: 'Laser source (CO₂ / fiber / diode)' },
    { dotX: mL + 148, dotY: 104, label: 'Mirror 1 — beam steering (45°)' },
    { dotX: mL + 250, dotY: 104, label: 'Mirror 2 — beam steering (45°)' },
    { dotX: mL + 250, dotY: 178, label: 'Focusing lens / F-theta lens' },
    { dotX: mL + 250, dotY: 230, label: 'Focal point — minimum spot size' },
    { dotX: mL + 310, dotY: 290, label: 'Workpiece on honeycomb table' },
    { dotX: mL + 68,  dotY: 340, label: 'Fume extractor / air-assist nozzle' },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Laser Engraving Machine — Anatomy &amp; Beam Path</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <linearGradient id="machGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#b0bec5"/>
            <stop offset="100%" stopColor="#78909c"/>
          </linearGradient>
          <linearGradient id="beamGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#c0392b" stopOpacity="0.9"/>
            <stop offset="100%" stopColor="#e07b00" stopOpacity="0.6"/>
          </linearGradient>
          <marker id="machArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#546e7a"/>
          </marker>
          <marker id="beamArrR" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <filter id="beamGlow">
            <feGaussianBlur stdDeviation="2" result="blur"/>
            <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
          </filter>
        </defs>

        {/* ── Left annotation labels ── */}
        {annots.map(({ dotX, dotY, label }, i) => (
          <g key={i}>
            <text x={labelMaxX} y={dotY + 4} textAnchor="end" fontSize="10" fill="#333">{label}</text>
            <line x1={labelMaxX + 4} y1={dotY} x2={dotX - 5} y2={dotY}
                  stroke="#546e7a" strokeWidth="1" strokeDasharray="4,3"/>
            <circle cx={dotX} cy={dotY} r={3} fill="#546e7a"/>
          </g>
        ))}

        {/* ── Machine frame ── */}
        <rect x={mL} y={20} width={390} height={390} rx={6}
              fill="none" stroke="#90a4ae" strokeWidth="2" strokeDasharray="6,4"/>
        <text x={mL + 195} y={15} textAnchor="middle" fontSize="9" fill="#90a4ae">machine enclosure</text>

        {/* ── Laser source ── */}
        <rect x={mL + 20} y={28} width={96} height={48} rx={4} fill="url(#machGrad)" stroke="#455a64" strokeWidth="1.5"/>
        <text x={mL + 68} y={51} textAnchor="middle" fontSize="10" fill="#fff" fontWeight="700">LASER</text>
        <text x={mL + 68} y={65} textAnchor="middle" fontSize="8.5" fill="#e0e8f0">SOURCE</text>

        {/* ── Beam path: horizontal from source to mirror 1 ── */}
        <line x1={mL + 116} y1={52} x2={mL + 148} y2={52}
              stroke="#c0392b" strokeWidth="2.5" strokeDasharray="none"
              markerEnd="url(#beamArrR)" filter="url(#beamGlow)" opacity="0.85"/>

        {/* ── Mirror 1 (45° deflects beam downward) ── */}
        <rect x={mL + 140} y={96} width={16} height={16} rx={2}
              fill="#e0e8f0" stroke="#455a64" strokeWidth="1.5"
              transform={`rotate(45 ${mL+148} ${mL+148-44})`}/>
        {/* Simplified as a rotated line */}
        <line x1={mL + 140} y1={112} x2={mL + 156} y2={96}
              stroke="#90a4ae" strokeWidth="3" strokeLinecap="round"/>

        {/* Beam: horizontal seg reaching mirror 1 */}
        <line x1={mL + 116} y1={52} x2={mL + 148} y2={52}
              stroke="#c0392b" strokeWidth="2" opacity="0.8"/>

        {/* Beam: vertical from mirror 1 to mirror 2 top */}
        <line x1={mL + 148} y1={52} x2={mL + 148} y2={96}
              stroke="#c0392b" strokeWidth="2" opacity="0.8" markerEnd="url(#beamArrR)"/>

        {/* ── Gantry X-axis rail ── */}
        <rect x={mL + 20} y={88} width={360} height={14} rx={3} fill="url(#machGrad)" stroke="#546e7a" strokeWidth="1"/>
        <text x={mL + 200} y={100} textAnchor="middle" fontSize="8" fill="#fff">X-axis gantry rail</text>

        {/* ── Carriage ── */}
        <rect x={mL + 220} y={84} width={60} height={22} rx={3} fill="#b0bec5" stroke="#546e7a" strokeWidth="1.2"/>
        <text x={mL + 250} y={99} textAnchor="middle" fontSize="8" fill="#fff">carriage</text>

        {/* ── Mirror 2 on carriage ── */}
        <line x1={mL + 240} y1={118} x2={mL + 260} y2={102}
              stroke="#90a4ae" strokeWidth="3" strokeLinecap="round"/>

        {/* Beam: horizontal from mirror1 post-deflect to mirror2 */}
        <line x1={mL + 148} y1={104} x2={mL + 248} y2={104}
              stroke="#c0392b" strokeWidth="2" opacity="0.8" markerEnd="url(#beamArrR)"/>

        {/* ── Lens housing / head ── */}
        <rect x={mL + 226} y={130} width={48} height={52} rx={4} fill="#546e7a" stroke="#37474f" strokeWidth="1.5"/>
        <text x={mL + 250} y={152} textAnchor="middle" fontSize="8.5" fill="#fff" fontWeight="700">LENS</text>
        <text x={mL + 250} y={165} textAnchor="middle" fontSize="8" fill="#b0bec5">HEAD</text>
        {/* Air-assist nozzle at bottom of head */}
        <polygon points={`${mL+238},182 ${mL+262},182 ${mL+255},198 ${mL+245},198`}
                 fill="#78909c" stroke="#546e7a" strokeWidth="1"/>

        {/* Beam: vertical from mirror2 down through lens ── */}
        <line x1={mL + 250} y1={104} x2={mL + 250} y2={130}
              stroke="#c0392b" strokeWidth="2" opacity="0.8" markerEnd="url(#beamArrR)"/>

        {/* Converging beam below lens */}
        <path d={`M ${mL+238},182 L ${mL+250},230 L ${mL+262},182`}
              fill="none" stroke="#c0392b" strokeWidth="1.5" opacity="0.7" strokeDasharray="3,2"/>

        {/* Focal spot */}
        <circle cx={mL + 250} cy={230} r={4} fill="#c0392b" filter="url(#beamGlow)"/>
        <text x={mL + 268} y={234} fontSize="9" fill="#c0392b" fontWeight="700">focal spot</text>
        <text x={mL + 268} y={246} fontSize="8.5" fill="#c0392b">Ø 0.05–0.5 mm</text>

        {/* Diverging beam below focal point */}
        <path d={`M ${mL+250},230 L ${mL+235},280 M ${mL+250},230 L ${mL+265},280`}
              fill="none" stroke="#c0392b" strokeWidth="1" opacity="0.3" strokeDasharray="2,3"/>

        {/* ── Workpiece ── */}
        <rect x={mL + 100} y={278} width={250} height={36} rx={3}
              fill="#e07b00" stroke="#bf6000" strokeWidth="1.5" opacity="0.88"/>
        <text x={mL + 225} y={299} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">Workpiece</text>

        {/* ── Honeycomb table ── */}
        {Array.from({length:12}, (_, i) => i).map(i => (
          <g key={i}>
            <line x1={mL + 100 + i*22} y1={314} x2={mL + 111 + i*22} y2={330}
                  stroke="#78909c" strokeWidth="1" opacity="0.6"/>
            <line x1={mL + 111 + i*22} y1={314} x2={mL + 100 + i*22} y2={330}
                  stroke="#78909c" strokeWidth="1" opacity="0.6"/>
          </g>
        ))}
        <rect x={mL + 100} y={314} width={250} height={18} rx={0}
              fill="#b0bec5" stroke="#78909c" strokeWidth="1" opacity="0.4"/>
        <text x={mL + 225} y={327} textAnchor="middle" fontSize="8" fill="#546e7a">honeycomb bed</text>

        {/* ── Fume extractor port ── */}
        <rect x={mL + 20} y={320} width={70} height={28} rx={3} fill="#546e7a" stroke="#37474f" strokeWidth="1.2"/>
        <text x={mL + 55} y={336} textAnchor="middle" fontSize="8.5" fill="#fff">EXHAUST</text>
        <line x1={mL + 20} y1={334} x2={mL + 5} y2={334}
              stroke="#546e7a" strokeWidth="3" markerEnd="url(#machArr)"/>

        {/* Y-axis rail label */}
        <rect x={mL + 20} y={120} width={14} height={160} rx={3} fill="#b0bec5" stroke="#78909c" strokeWidth="1" opacity="0.6"/>
        <text x={mL + 8} y={200} textAnchor="middle" fontSize="8" fill="#78909c"
              transform={`rotate(-90 ${mL+8} 200)`}>Y-axis rail</text>

        {/* ── Right info panel ── */}
        <rect x={630} y={16} width={342} height={428} rx={5} fill="#fff" stroke="#b6dfc0" strokeWidth="1.2"/>
        <text x={801} y={36} textAnchor="middle" fontSize="13" fill="#145a24" fontWeight="700">Key Specifications</text>

        {[
          { param:'Working area',   val:'300×200 mm to\n1300×900 mm (typical)' },
          { param:'Positioning acc.',val:'±0.01 mm (linear enc.)\n±0.02 mm (belt drive)' },
          { param:'Travel speed',   val:'Up to 1000 mm/s\n(galvo: up to 10,000 mm/s)' },
          { param:'Z-axis range',   val:'Motorised: 0–300 mm\nautofocus ±0.5 mm' },
          { param:'Power range',    val:'CO₂: 10–400 W\nFiber: 10–100 W' },
          { param:'Spot size',      val:'CO₂: 0.1–0.5 mm\nFiber: 0.02–0.1 mm' },
        ].map(({ param, val }, i) => {
          const ry = 46 + i * 62;
          return (
            <g key={i}>
              <rect x={638} y={ry} width={326} height={56} rx={3}
                    fill={i%2===0?'#edf7f0':'#fff'} stroke="#b6dfc0" strokeWidth="1"/>
              <text x={646} y={ry+18} fontSize="11" fill="#145a24" fontWeight="700">{param}</text>
              {val.split('\n').map((line, li) => (
                <text key={li} x={646} y={ry+33+li*14} fontSize="10" fill="#444">{line}</text>
              ))}
            </g>
          );
        })}
        <text x={801} y={424} textAnchor="middle" fontSize="10" fill="#546e7a" fontStyle="italic">
          Galvo-head systems replace X/Y gantry for speeds up to 10 m/s
        </text>
      </svg>
      <div style={S.dCaption}>A gantry-style CO₂ laser engraver uses a fixed laser tube with a stepper/servo-driven X–Y gantry that repositions two beam-steering mirrors. The focused beam travels through a final converging lens to a spot of 0.1–0.5 mm at the focal point. Air assist from the nozzle clears debris and suppresses flame; a fume extractor removes hazardous vapours. Galvo-head systems replace the gantry with two fast scanning mirrors (up to 10,000 mm/s) for high-throughput marking.</div>
    </div>
  );
}

// ── Diagram 2: Laser–Material Interaction Cross-Section ────────────
function DiagramLaserMaterialInteraction() {
  const W = 980, H = 420;

  // Left annotation, centre cross-section, right zone legend panel
  const labelMaxX = 205;
  const secL = 218, secW = 340, secCX = 218 + 170;

  // Cross-section zones from top (surface) to bottom
  const zones = [
    { label:'Plasma / vapour plume',   h:38, fill:'#e07b00', fg:'#fff',     opacity:0.7, desc:'Vaporised material ejected upward' },
    { label:'Ablation / melt zone',    h:26, fill:'#c0392b', fg:'#fff',     opacity:0.85,desc:'Direct material removal by vaporisation' },
    { label:'Resolidified melt layer', h:14, fill:'#922b21', fg:'#fff',     opacity:0.8, desc:'Re-cast layer; may be porous' },
    { label:'Heat-affected zone (HAZ)',h:22, fill:'#e07b00', fg:'#fff',     opacity:0.55,desc:'Thermal alteration without removal' },
    { label:'Base material',           h:80, fill:'#c8944a', fg:'#fff',     opacity:0.9, desc:'Unaffected substrate' },
  ];

  // Annotation dot positions
  const annots = [
    { dotY: 56,  label: 'Laser beam (focused)' },
    { dotY: 108, label: 'Plasma / vapour plume' },
    { dotY: 150, label: 'Ablation / melt zone' },
    { dotY: 172, label: 'Re-solidified layer' },
    { dotY: 192, label: 'HAZ (heat-affected zone)' },
    { dotY: 225, label: 'Unaffected base material' },
  ];

  const zoneBaseY = 90; // where zones start in SVG

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Laser–Material Interaction — Ablation Zones &amp; Heat-Affected Zone (HAZ)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <linearGradient id="beamConv" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#c0392b" stopOpacity="0.05"/>
            <stop offset="100%" stopColor="#c0392b" stopOpacity="0.8"/>
          </linearGradient>
          <linearGradient id="hazGrad" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#e07b00" stopOpacity="0.7"/>
            <stop offset="100%" stopColor="#e07b00" stopOpacity="0"/>
          </linearGradient>
          <filter id="glow2">
            <feGaussianBlur stdDeviation="3" result="b"/>
            <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
          </filter>
          <marker id="intArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#546e7a"/>
          </marker>
          <marker id="dimArr2" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#1e7a36"/>
          </marker>
        </defs>

        {/* Left annotation labels */}
        {annots.map(({ dotY, label }, i) => (
          <g key={i}>
            <text x={labelMaxX} y={dotY + 4} textAnchor="end" fontSize="10" fill="#333">{label}</text>
            <line x1={labelMaxX + 4} y1={dotY} x2={secL - 5} y2={dotY}
                  stroke="#546e7a" strokeWidth="1" strokeDasharray="4,3"/>
            <circle cx={secL - 5} cy={dotY} r={3} fill="#546e7a"/>
          </g>
        ))}

        {/* Converging laser beam above surface */}
        <path d={`M ${secCX - 40},30 L ${secCX},90 L ${secCX + 40},30`}
              fill="url(#beamConv)" stroke="none"/>
        <line x1={secCX - 40} y1={30} x2={secCX} y2={90}
              stroke="#c0392b" strokeWidth="1.5" opacity="0.7"/>
        <line x1={secCX + 40} y1={30} x2={secCX} y2={90}
              stroke="#c0392b" strokeWidth="1.5" opacity="0.7"/>
        {/* Focal point glow */}
        <circle cx={secCX} cy={zoneBaseY} r={6} fill="#c0392b" filter="url(#glow2)" opacity="0.9"/>

        {/* Vapour plume above surface */}
        {[0,-8,8,-14,14,-6,6].map((dx, pi) => (
          <path key={pi}
                d={`M ${secCX+dx},${zoneBaseY} Q ${secCX+dx*1.5},${zoneBaseY-20+pi*2} ${secCX+dx*0.5},${zoneBaseY-42}`}
                fill="none" stroke="#e07b00" strokeWidth="1.2" opacity="0.5" strokeDasharray="2,2"/>
        ))}
        <text x={secCX} y={zoneBaseY - 46} textAnchor="middle" fontSize="9" fill="#e07b00" fontWeight="700">
          vapour plume
        </text>

        {/* Material cross-section zones */}
        {(()=>{
          let y = zoneBaseY;
          return zones.map(({ label, h, fill, fg, opacity, desc }, i) => {
            const gy = y;
            y += h;
            // HAZ extends sideways
            const isHAZ = label.includes('HAZ');
            return (
              <g key={i}>
                {isHAZ ? (
                  // HAZ: wider, with gradient showing lateral heat spread
                  <g>
                    <rect x={secL - 40} y={gy} width={secW + 80} height={h}
                          fill={fill} opacity={opacity * 0.35} rx={0}/>
                    <rect x={secL} y={gy} width={secW} height={h}
                          fill={fill} opacity={opacity} rx={0}/>
                    {/* Lateral gradient overlays */}
                    <rect x={secL - 40} y={gy} width={40} height={h}
                          fill="url(#hazGrad)" opacity="0.5"
                          transform={`scale(-1,1) translate(${-(secL)*2} 0)`}/>
                    <rect x={secL + secW} y={gy} width={40} height={h}
                          fill="url(#hazGrad)" opacity="0.5"/>
                  </g>
                ) : (
                  <rect x={secL} y={gy} width={secW} height={h} fill={fill} opacity={opacity} rx={0}/>
                )}
                {h > 16 && (
                  <text x={secCX} y={gy + h/2 + 4} textAnchor="middle" fontSize="9" fill={fg} fontWeight="600">
                    {label}
                  </text>
                )}
              </g>
            );
          });
        })()}

        {/* Crater profile overlay */}
        <path d={`M ${secCX - 28},${zoneBaseY} Q ${secCX},${zoneBaseY + 56} ${secCX + 28},${zoneBaseY}`}
              fill="none" stroke="#333" strokeWidth="1" strokeDasharray="3,2" opacity="0.6"/>

        {/* Dimension lines */}
        {/* Engraving depth */}
        {(()=>{
          const dx = secL + secW + 18;
          const topY = zoneBaseY;
          const botY = zoneBaseY + zones[0].h + zones[1].h + zones[2].h;
          return (
            <g>
              <line x1={dx} y1={topY} x2={dx} y2={botY} stroke="#1e7a36" strokeWidth="1.5"/>
              <line x1={dx-5} y1={topY} x2={dx+5} y2={topY} stroke="#1e7a36" strokeWidth="1.5"/>
              <line x1={dx-5} y1={botY} x2={dx+5} y2={botY} stroke="#1e7a36" strokeWidth="1.5"/>
              <text x={dx+8} y={(topY+botY)/2} fontSize="9" fill="#1e7a36" fontWeight="700">Engrave</text>
              <text x={dx+8} y={(topY+botY)/2+12} fontSize="9" fill="#1e7a36" fontWeight="700">depth</text>
              <text x={dx+8} y={(topY+botY)/2+24} fontSize="9" fill="#1e7a36">10µm–5mm</text>
            </g>
          );
        })()}

        {/* Spot width dimension */}
        {(()=>{
          const dy2 = zoneBaseY + zones[0].h + zones[1].h + 8;
          return (
            <g>
              <line x1={secCX - 28} y1={dy2} x2={secCX + 28} y2={dy2} stroke="#c0392b" strokeWidth="1.5"/>
              <line x1={secCX - 28} y1={dy2-4} x2={secCX - 28} y2={dy2+4} stroke="#c0392b" strokeWidth="1.5"/>
              <line x1={secCX + 28} y1={dy2-4} x2={secCX + 28} y2={dy2+4} stroke="#c0392b" strokeWidth="1.5"/>
              <text x={secCX} y={dy2+14} textAnchor="middle" fontSize="8.5" fill="#c0392b">spot diameter</text>
            </g>
          );
        })()}

        {/* Right info panel */}
        <rect x={638} y={16} width={334} height={H - 28} rx={5} fill="#fff" stroke="#b6dfc0" strokeWidth="1.2"/>
        <text x={805} y={36} textAnchor="middle" fontSize="13" fill="#145a24" fontWeight="700">Zone Descriptions</text>

        {[
          { zone:'Vapour plume',        col:'#e07b00', body:'Material ejected as vapour + particles.\nContains toxic fumes — exhaust mandatory.\nPlasma forms at high power density.' },
          { zone:'Ablation / melt zone',col:'#c0392b', body:'Direct material removal by vaporisation.\nDepth controlled by power, speed & passes.\nClean edges require high power density.' },
          { zone:'Re-solidified layer', col:'#922b21', body:'Thin re-cast layer of resolidified melt.\nCan be porous, brittle, or amorphous.\nRemove by post-process abrasion if needed.' },
          { zone:'HAZ (heat-affected)', col:'#e07b00', body:'Thermal gradient without removal.\nMay alter hardness, microstructure.\nMinimise with pulsed/ultra-short pulses.' },
          { zone:'Base material',       col:'#c8944a', body:'Unaffected substrate below HAZ.\nDefines the performance of the part.\nHAZ width depends on thermal diffusivity.' },
        ].map(({ zone, col, body }, i) => {
          const ry = 46 + i * 68;
          return (
            <g key={i}>
              <rect x={646} y={ry} width={320} height={62} rx={3}
                    fill={i%2===0?'#edf7f0':'#fff'} stroke="#b6dfc0" strokeWidth="1"/>
              <rect x={648} y={ry+4} width={6} height={54} rx={2} fill={col}/>
              <text x={662} y={ry+18} fontSize="11" fill="#145a24" fontWeight="700">{zone}</text>
              {body.split('\n').map((line, li) => (
                <text key={li} x={662} y={ry+32+li*14} fontSize="9.5" fill="#444">{line}</text>
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>When the focused laser beam strikes material, it creates a cascade of thermal events. At the focal point, power density exceeds 10⁶ W/cm²; material instantly vaporises, creating a crater. Surrounding the crater, a heat-affected zone (HAZ) forms where temperature gradients alter material properties without removal. Minimising HAZ requires short pulse durations (nanosecond to femtosecond) and high repetition rates rather than continuous wave irradiation.</div>
    </div>
  );
}

// ── Diagram 3: Laser Types Comparison ─────────────────────────────
function DiagramLaserTypes() {
  const W = 960, H = 500;

  const laserTypes = [
    {
      name: 'CO₂ Laser',
      wavelength: '10,600 nm', wl: 10600,
      medium: 'Gas (CO₂/N₂/He)',
      power: '10–400 W',
      spotSize: '0.1–0.5 mm',
      col: '#c0392b',
      bg: '#fff5f0',
      bestFor: ['Wood, acrylic, leather','Fabric, glass, rubber','Paper, cardboard','Organic materials'],
      avoid: 'Clear plastics (PET), polycarbonate',
      efficiency: 10,
      cost: 6,
      metalMark: 1,
    },
    {
      name: 'Fiber Laser',
      wavelength: '1,060 nm', wl: 1060,
      medium: 'Doped fiber (Yb)',
      power: '10–100 W',
      spotSize: '0.02–0.1 mm',
      col: '#1565c0',
      bg: '#f0f4ff',
      bestFor: ['Steel, aluminium, copper','Titanium, precious metals','Hard plastics (ABS, nylon)','Ceramics, anodised Al'],
      avoid: 'Wood, fabrics (IR transparent)',
      efficiency: 25,
      cost: 7,
      metalMark: 10,
    },
    {
      name: 'Diode Laser',
      wavelength: '445–980 nm', wl: 450,
      medium: 'Semiconductor',
      power: '1–30 W',
      spotSize: '0.05–0.2 mm',
      col: '#6a1b9a',
      bg: '#f8f0ff',
      bestFor: ['Wood, leather, cork','Dark-coloured materials','Light anodised metals','Low-cost marking tasks'],
      avoid: 'Transparent/white materials,\nmirror-finish metals',
      efficiency: 30,
      cost: 9,
      metalMark: 3,
    },
    {
      name: 'Nd:YAG / UV Laser',
      wavelength: '355–1064 nm', wl: 355,
      medium: 'Crystal / DPSS',
      power: '5–50 W',
      spotSize: '0.01–0.1 mm',
      col: '#1e7a36',
      bg: '#f0fff4',
      bestFor: ['Silicon, glass, ceramics','Fine jewellery, PCBs','Medical devices','UV-sensitive materials'],
      avoid: 'High-volume bulk removal\n(too slow per watt)',
      efficiency: 5,
      cost: 4,
      metalMark: 8,
    },
  ];

  const panelW = (W - 20) / laserTypes.length;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Laser Types for Engraving — CO₂ vs Fiber vs Diode vs Nd:YAG / UV</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {laserTypes.map(({ name, wavelength, wl, medium, power, spotSize, col, bg, bestFor, avoid, efficiency, cost, metalMark }, li) => {
          const px = 10 + li * panelW;
          const pw = panelW - 8;
          const cx = px + pw / 2;

          // Wavelength visualisation (colour bar)
          const wlColor = wl > 5000 ? '#c0392b' : wl > 700 ? '#e07b00' : wl > 600 ? '#ff5722' : wl > 500 ? '#8bc34a' : wl > 400 ? '#3f51b5' : '#6a1b9a';

          return (
            <g key={li}>
              <rect x={px} y={8} width={pw} height={H - 16} rx={5} fill={bg} stroke={col} strokeWidth="1.5"/>

              {/* Laser name */}
              <text x={cx} y={28} textAnchor="middle" fontSize="12" fill={col} fontWeight="700">{name}</text>

              {/* Wavelength bar */}
              <rect x={px + 8} y={34} width={pw - 16} height={12} rx={3} fill="#e0e0e0"/>
              <rect x={px + 8} y={34} width={pw - 16} height={12} rx={3} fill={wlColor} opacity="0.6"/>
              <text x={cx} y={44} textAnchor="middle" fontSize="9" fill="#fff" fontWeight="700">{wavelength}</text>

              {/* Specs */}
              {[
                { label:'Medium', val:medium },
                { label:'Power',  val:power  },
                { label:'Spot',   val:spotSize},
              ].map(({ label, val }, si) => (
                <g key={si}>
                  <text x={px + 10} y={66 + si * 18} fontSize="9" fill="#546e7a" fontWeight="700">{label}:</text>
                  <text x={px + 52} y={66 + si * 18} fontSize="9.5" fill="#333">{val}</text>
                </g>
              ))}

              {/* Score bars: efficiency, cost, metal marking */}
              {[
                { label:'Wall-plug eff.', val:efficiency, col2:'#1e7a36', suffix:'%' },
                { label:'Cost efficiency', val:cost, col2:'#e07b00', suffix:'/10' },
                { label:'Metal marking', val:metalMark, col2:'#1565c0', suffix:'/10' },
              ].map(({ label, val, suffix, col2 }, bi) => {
                const barY = 126 + bi * 26;
                const barFrac = Math.min(val, 10) / 10;
                const barPx = barFrac * (pw - 16);
                return (
                  <g key={bi}>
                    <text x={px + 8} y={barY} fontSize="8.5" fill="#555">{label}</text>
                    <rect x={px + 8} y={barY + 3} width={pw - 16} height={12}
                          rx={3} fill="#e8f5ec" stroke="#b6dfc0" strokeWidth="0.5"/>
                    <rect x={px + 8} y={barY + 3} width={barPx} height={12}
                          rx={3} fill={col2} opacity="0.8"/>
                    <text x={px + pw - 6} y={barY + 13} textAnchor="end" fontSize="8" fill="#333" fontWeight="700">{val}{suffix}</text>
                  </g>
                );
              })}

              {/* Best for */}
              <rect x={px + 6} y={212} width={pw - 12} height={bestFor.length * 16 + 22} rx={3}
                    fill="#e8f5ec" stroke="#2e8b47" strokeWidth="1"/>
              <text x={px + 12} y={227} fontSize="9.5" fill="#1e7a36" fontWeight="700">Best for:</text>
              {bestFor.map((item, ii) => (
                <text key={ii} x={px + 12} y={242 + ii * 16} fontSize="9" fill="#145a24">✔ {item}</text>
              ))}

              {/* Avoid */}
              {(()=>{
                const avoidY = 212 + bestFor.length * 16 + 28;
                return (
                  <g>
                    <rect x={px + 6} y={avoidY} width={pw - 12} height={avoid.split('\n').length * 14 + 24} rx={3}
                          fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
                    <text x={px + 12} y={avoidY + 15} fontSize="9.5" fill="#c0392b" fontWeight="700">Avoid for:</text>
                    {avoid.split('\n').map((line, li2) => (
                      <text key={li2} x={px + 12} y={avoidY + 29 + li2 * 14} fontSize="8.5" fill="#922b21">{line}</text>
                    ))}
                  </g>
                );
              })()}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Laser wavelength is the single most important parameter for material absorption. CO₂ at 10.6 µm is absorbed by organic materials (wood, acrylic, leather) but reflected by bare metals. Fiber at 1.06 µm is absorbed by metals and dark plastics but passes through wood. Diode lasers (445 nm) offer the best cost-per-watt for entry-level systems. UV lasers (355 nm) enable cold ablation with minimal HAZ, essential for delicate substrates like glass, silicon, and medical devices.</div>
    </div>
  );
}

// ── Diagram 4: Beam Profile & Focal Depth ─────────────────────────
function DiagramBeamProfile() {
  const W = 960, H = 380;

  // Left: Gaussian beam profile diagram
  // Right: depth-of-focus and defocus effect panel

  const beamCX = 260;
  const waistY  = 200;  // y of focal plane / beam waist

  // Beam half-width at various y positions (Gaussian beam: w(z) = w0 * sqrt(1 + (z/zR)^2))
  const w0 = 6;    // beam waist radius in px
  const zR = 60;   // Rayleigh range in px
  const bw = z => w0 * Math.sqrt(1 + (z / zR) ** 2);

  const beamPoints = Array.from({ length: 160 }, (_, i) => i - 80);  // z from -80 to +80
  const beamPath = (side) =>
    beamPoints.map((z, i) => {
      const w = bw(z);
      return (i === 0 ? 'M' : 'L') + `${beamCX},${waistY + z}`;
    }).join(' ');

  const leftEdge = beamPoints.map((z, i) =>
    (i === 0 ? 'M' : 'L') + `${beamCX - bw(z)},${waistY + z}`
  ).join(' ');
  const rightEdge = beamPoints.map((z, i) =>
    (i === 0 ? 'M' : 'L') + `${beamCX + bw(z)},${waistY + z}`
  ).join(' ');

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Gaussian Beam Profile — Spot Size, Rayleigh Range &amp; Depth of Focus</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <linearGradient id="beamFill" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#c0392b" stopOpacity="0"/>
            <stop offset="50%" stopColor="#c0392b" stopOpacity="0.7"/>
            <stop offset="100%" stopColor="#c0392b" stopOpacity="0"/>
          </linearGradient>
          <marker id="bpArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#333"/>
          </marker>
          <marker id="bpArrG" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#1e7a36"/>
          </marker>
          <marker id="bpArrR" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <filter id="beamGlowPro">
            <feGaussianBlur stdDeviation="2.5" result="b"/>
            <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
          </filter>
        </defs>

        {/* ── LEFT: Gaussian beam diagram ── */}

        {/* Beam boundary lines */}
        <path d={leftEdge}  fill="none" stroke="#c0392b" strokeWidth="1.5" opacity="0.8"/>
        <path d={rightEdge} fill="none" stroke="#c0392b" strokeWidth="1.5" opacity="0.8"/>

        {/* Beam interior fill (intensity gradient) */}
        {beamPoints.filter((_, i) => i % 4 === 0).map((z, i) => {
          const w = bw(z);
          const intensity = w0 / w;
          return (
            <line key={i}
                  x1={beamCX - w} y1={waistY + z}
                  x2={beamCX + w} y2={waistY + z}
                  stroke="#c0392b" strokeWidth="1"
                  opacity={intensity * 0.45}/>
          );
        })}

        {/* Beam waist marker */}
        <line x1={beamCX - w0 - 16} y1={waistY} x2={beamCX + w0 + 16} y2={waistY}
              stroke="#1e7a36" strokeWidth="1.5" strokeDasharray="4,2"/>
        <circle cx={beamCX} cy={waistY} r={w0} fill="#c0392b" opacity="0.5"
                filter="url(#beamGlowPro)"/>
        <text x={beamCX + w0 + 18} y={waistY + 4} fontSize="10" fill="#1e7a36" fontWeight="700">w₀ (beam waist)</text>

        {/* Rayleigh range markers */}
        <line x1={beamCX - bw(zR) - 10} y1={waistY + zR} x2={beamCX + bw(zR) + 10} y2={waistY + zR}
              stroke="#e07b00" strokeWidth="1" strokeDasharray="3,2"/>
        <line x1={beamCX - bw(-zR) - 10} y1={waistY - zR} x2={beamCX + bw(-zR) + 10} y2={waistY - zR}
              stroke="#e07b00" strokeWidth="1" strokeDasharray="3,2"/>
        {/* z_R dimension */}
        <line x1={beamCX + bw(zR) + 14} y1={waistY} x2={beamCX + bw(zR) + 14} y2={waistY + zR}
              stroke="#e07b00" strokeWidth="1.2"/>
        <line x1={beamCX + bw(zR) + 9} y1={waistY} x2={beamCX + bw(zR) + 19} y2={waistY} stroke="#e07b00" strokeWidth="1.2"/>
        <line x1={beamCX + bw(zR) + 9} y1={waistY + zR} x2={beamCX + bw(zR) + 19} y2={waistY + zR} stroke="#e07b00" strokeWidth="1.2"/>
        <text x={beamCX + bw(zR) + 22} y={waistY + zR/2 + 4} fontSize="9.5" fill="#e07b00" fontWeight="700">z_R</text>
        <text x={beamCX + bw(zR) + 22} y={waistY + zR/2 + 16} fontSize="8.5" fill="#e07b00">Rayleigh</text>
        <text x={beamCX + bw(zR) + 22} y={waistY + zR/2 + 27} fontSize="8.5" fill="#e07b00">range</text>

        {/* Spot width annotation */}
        <line x1={beamCX - w0} y1={waistY + 10} x2={beamCX + w0} y2={waistY + 10}
              stroke="#c0392b" strokeWidth="1.5" markerStart="url(#bpArrR)" markerEnd="url(#bpArrR)"/>
        <text x={beamCX} y={waistY + 24} textAnchor="middle" fontSize="9" fill="#c0392b" fontWeight="700">2w₀</text>

        {/* Optical axis */}
        <line x1={20} y1={waistY} x2={beamCX - w0 - 20} y2={waistY}
              stroke="#333" strokeWidth="1" strokeDasharray="4,4" opacity="0.4"/>
        <line x1={beamCX + w0 + 20} y1={waistY} x2={490} y2={waistY}
              stroke="#333" strokeWidth="1" strokeDasharray="4,4" opacity="0.4"/>

        {/* Propagation axis */}
        <line x1={beamCX} y1={100} x2={beamCX} y2={310}
              stroke="#333" strokeWidth="1" strokeDasharray="2,3" opacity="0.3"/>
        <text x={beamCX} y={95} textAnchor="middle" fontSize="10" fill="#c0392b" fontWeight="700">beam axis</text>

        {/* Formula box */}
        <rect x={20} y={H - 100} width={470} height={90} rx={4} fill="#e8f5ec" stroke="#2e8b47" strokeWidth="1"/>
        <text x={28} y={H-82} fontSize="10" fill="#145a24" fontWeight="700">Beam waist: w₀ = (λ · f) / (π · r_beam)</text>
        <text x={28} y={H-68} fontSize="9.5" fill="#444" fontFamily="'Courier New',monospace">  λ=wavelength, f=focal length, r_beam=input beam radius</text>
        <text x={28} y={H-50} fontSize="10" fill="#145a24" fontWeight="700">Rayleigh range: z_R = π · w₀² / λ</text>
        <text x={28} y={H-36} fontSize="9.5" fill="#444" fontFamily="'Courier New',monospace">  depth over which spot area stays within 2× minimum</text>

        {/* ── RIGHT: Depth of focus effect panels ── */}
        <rect x={500} y={10} width={455} height={H - 20} rx={5} fill="#fff" stroke="#b6dfc0" strokeWidth="1.2"/>
        <text x={727} y={30} textAnchor="middle" fontSize="13" fill="#145a24" fontWeight="700">Focus Position Effect</text>

        {[
          { label:'In focus', dy:0, quality:'Sharp, deep engraving', col:'#1e7a36', sparkSize:4 },
          { label:'Slightly defocused (+z_R)', dy:zR, quality:'Wider kerf, shallower depth', col:'#e07b00', sparkSize:8 },
          { label:'Heavily defocused', dy:zR*2.2, quality:'Broad, shallow, low quality', col:'#c0392b', sparkSize:14 },
        ].map(({ label, dy, quality, col, sparkSize }, fi) => {
          const panX = 510, panW = 200;
          const panY = 46 + fi * 102;
          const fx = panX + 44;
          const fw = panX + panW - 10;
          const wAtZ = bw(dy);
          const scaledW = Math.max(4, wAtZ * 2.5);

          return (
            <g key={fi}>
              <rect x={panX} y={panY} width={panW + 80} height={92} rx={3}
                    fill={fi%2===0?'#edf7f0':'#fff'} stroke={col} strokeWidth="1"/>
              <text x={panX + 8} y={panY + 16} fontSize="10" fill={col} fontWeight="700">{label}</text>
              <text x={panX + 8} y={panY + 30} fontSize="9" fill="#555">{quality}</text>
              {/* Cross-section of beam at this focus position */}
              <line x1={fx} y1={panY + 50} x2={fw} y2={panY + 50}
                    stroke="#c8944a" strokeWidth="10" strokeLinecap="round" opacity="0.8"/>
              {/* Beam spot size indicator */}
              <ellipse cx={(fx + fw)/2} cy={panY + 50} rx={scaledW} ry={scaledW * 0.4}
                       fill={col} opacity="0.7" filter="url(#beamGlowPro)"/>
              {/* Engraved kerf */}
              <path d={`M ${(fx+fw)/2 - scaledW} ${panY+46} Q ${(fx+fw)/2} ${panY+46+scaledW*0.5} ${(fx+fw)/2 + scaledW} ${panY+46}`}
                    fill="none" stroke="#333" strokeWidth="1" opacity="0.5"/>
              {/* Kerf width label */}
              <text x={fw + 10} y={panY + 54} fontSize="9" fill={col}>
                {`kerf ≈ ${(scaledW * 0.08 + 0.05).toFixed(2)} mm`}
              </text>
            </g>
          );
        })}

        {/* M² quality factor note */}
        <rect x={510} y={350} width={440} height={24} rx={3} fill="#e8f5ec" stroke="#2e8b47" strokeWidth="1"/>
        <text x={518} y={366} fontSize="10" fill="#145a24" fontWeight="700">M² (beam quality factor): </text>
        <text x={630} y={366} fontSize="10" fill="#444">ideal Gaussian = 1.0; industrial CO₂ ≈ 1.1–1.3; fiber ≈ 1.05–1.2</text>
      </svg>
      <div style={S.dCaption}>The Gaussian beam profile defines how laser energy is distributed across the beam cross-section — maximum intensity at the centre (TEM₀₀ mode). The beam waist w₀ is the smallest achievable spot radius; the Rayleigh range z_R defines the depth over which the spot area remains within 2× minimum. For deep engraving of 3D objects, a long z_R is desirable; for fine surface marking, short focal length lenses minimise w₀ at the cost of z_R.</div>
    </div>
  );
}

// ── Diagram 5: Engraving Modes ─────────────────────────────────────
function DiagramEngravingModes() {
  const W = 960, H = 520;
  const panelW = (W - 20) / 3;

  const modes = [
    {
      title: 'Raster Engraving',
      subtitle: 'Line-by-line scanning',
      col: '#1e7a36',
      bg: '#f0fff4',
      icon: '≡',
      desc: 'Laser scans back-and-forth in parallel lines (like an inkjet printer). Each pass removes one layer. Multiple passes achieve greater depth.',
      params: [
        { label:'Line spacing (DPI)', val:'100–1200 DPI typical' },
        { label:'Speed', val:'100–1000 mm/s' },
        { label:'Passes', val:'1–20 for depth engraving' },
        { label:'Result', val:'Filled areas, photos, textures' },
      ],
      pros:['Fills large areas evenly','Photographic depth shading','Simple path planning'],
      cons:['Slow on sparse designs','Burn streaks on low DPI','High heat per unit area'],
    },
    {
      title: 'Vector Engraving',
      subtitle: 'Path-following (contour)',
      col: '#1565c0',
      bg: '#f0f4ff',
      icon: '⟋',
      desc: 'Laser follows the exact vector paths of the design. Used for outlines, text, and geometric shapes. Can also cut through at full power.',
      params: [
        { label:'Path following', val:'DXF / SVG / AI files' },
        { label:'Speed', val:'10–500 mm/s' },
        { label:'Passes', val:'1 (cut) or 2–5 (engrave)' },
        { label:'Result', val:'Lines, outlines, cuts' },
      ],
      pros:['Fast on outline designs','Sharp edge definition','Suitable for cutting'],
      cons:['Cannot fill large areas','Corner velocity affects depth','Over-burn at path ends'],
    },
    {
      title: '3D Relief Engraving',
      subtitle: 'Variable-depth grayscale',
      col: '#c0392b',
      bg: '#fff5f0',
      icon: '◈',
      desc: 'Grayscale image mapped to power or speed variation. Lighter pixels = less power = shallower cut. Creates topographic relief surfaces.',
      params: [
        { label:'Depth map', val:'8-bit grayscale image' },
        { label:'Max depth', val:'Up to 5 mm per material' },
        { label:'Resolution', val:'150–600 DPI for 3D' },
        { label:'Result', val:'Sculptural relief, 3D texture' },
      ],
      pros:['Photorealistic 3D relief','Single setup operation','No toolpath CAM needed'],
      cons:['Requires material testing','Very slow on large areas','Depth accuracy ±10–20%'],
    },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Laser Engraving Modes — Raster, Vector &amp; 3D Relief</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {modes.map(({ title, subtitle, col, bg, icon, desc, params, pros, cons }, mi) => {
          const px = 10 + mi * panelW;
          const pw = panelW - 8;
          const cx = px + pw / 2;

          return (
            <g key={mi}>
              <rect x={px} y={8} width={pw} height={H - 16} rx={5} fill={bg} stroke={col} strokeWidth="1.5"/>

              {/* Title */}
              <text x={cx} y={30} textAnchor="middle" fontSize="12" fill={col} fontWeight="700">{title}</text>
              <text x={cx} y={44} textAnchor="middle" fontSize="9.5" fill="#555">{subtitle}</text>

              {/* SVG illustration per mode */}
              {mi === 0 && (
                // Raster lines
                <g>
                  <rect x={px+10} y={54} width={pw-20} height={72} rx={3} fill="#c8944a" opacity="0.4" stroke="#906030" strokeWidth="1"/>
                  {[0,1,2,3,4,5,6,7,8].map(row => (
                    <g key={row}>
                      <line x1={row%2===0?px+12:px+pw-12} y1={62 + row*8}
                            x2={row%2===0?px+pw-12:px+12} y2={62 + row*8}
                            stroke={col} strokeWidth={row < 5 ? 2 : 1} opacity={row < 5 ? 0.8 : 0.4}/>
                      {row === 3 && (
                        // Active scan line
                        <circle cx={px+pw-14} cy={62+row*8} r={4} fill={col} opacity="0.9"/>
                      )}
                    </g>
                  ))}
                  <text x={cx} y={138} textAnchor="middle" fontSize="8.5" fill="#546e7a">bidirectional scan pattern</text>
                </g>
              )}
              {mi === 1 && (
                // Vector path
                <g>
                  <rect x={px+10} y={54} width={pw-20} height={72} rx={3} fill="#c8944a" opacity="0.4" stroke="#906030" strokeWidth="1"/>
                  {/* Letter A outline */}
                  <path d={`M ${cx},60 L ${cx-22},118 M ${cx},60 L ${cx+22},118 M ${cx-12},96 L ${cx+12},96`}
                        fill="none" stroke={col} strokeWidth="2.5" strokeLinecap="round"/>
                  {/* Laser head position */}
                  <circle cx={cx + 10} cy={82} r={4} fill={col} opacity="0.85"/>
                  <text x={cx} y={138} textAnchor="middle" fontSize="8.5" fill="#546e7a">vector path tracing</text>
                </g>
              )}
              {mi === 2 && (
                // 3D relief — topographic shading
                <g>
                  <rect x={px+10} y={54} width={pw-20} height={72} rx={3} fill="#c8944a" opacity="0.4" stroke="#906030" strokeWidth="1"/>
                  {/* Grayscale gradient blocks simulating depth */}
                  {Array.from({ length: 8 }, (_, ci) =>
                    Array.from({ length: 8 }, (_, ri) => {
                      const depth = Math.sin((ci/7)*Math.PI) * Math.sin((ri/7)*Math.PI);
                      return (
                        <rect key={`${ci}-${ri}`}
                              x={px + 12 + ci * (pw-22)/8}
                              y={56 + ri * 68/8}
                              width={(pw-22)/8}
                              height={68/8}
                              fill={col}
                              opacity={depth * 0.7}/>
                      );
                    })
                  )}
                  <text x={cx} y={138} textAnchor="middle" fontSize="8.5" fill="#546e7a">grayscale → depth map</text>
                </g>
              )}

              {/* Description */}
              {(()=>{
                const words = desc.split(' ');
                const lines = [];
                let line = '';
                for (const w of words) {
                  if (line && (line + ' ' + w).length > 34) { lines.push(line); line = w; }
                  else { line = line ? line + ' ' + w : w; }
                }
                if (line) lines.push(line);
                return lines.map((l, li) => (
                  <text key={li} x={px + 8} y={152 + li * 14} fontSize="9.5" fill="#333">{l}</text>
                ));
              })()}

              {/* Params */}
              <rect x={px+6} y={246} width={pw-12} height={params.length * 28 + 14} rx={3}
                    fill="#fff" stroke={col} strokeWidth="1" opacity="0.9"/>
              {params.map(({ label, val }, pi) => (
                <g key={pi}>
                  <text x={px+12} y={262 + pi * 28} fontSize="9" fill="#546e7a" fontWeight="700">{label}:</text>
                  <text x={px+12} y={275 + pi * 28} fontSize="9" fill="#333">{val}</text>
                </g>
              ))}

              {/* Pros/cons */}
              {(()=>{
                const pcY = 246 + params.length * 28 + 22;
                return (
                  <g>
                    {pros.map((p, i) => (
                      <text key={i} x={px + 10} y={pcY + i * 16} fontSize="9" fill="#1e7a36">✔ {p}</text>
                    ))}
                    {cons.map((c, i) => (
                      <text key={i} x={px + 10} y={pcY + pros.length * 16 + 6 + i * 16} fontSize="9" fill="#c0392b">✗ {c}</text>
                    ))}
                  </g>
                );
              })()}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Raster mode is the standard for area fills, images, and textures — the laser treats the design like a printer, scanning line by line. Vector mode traces outlines and paths, making it ideal for text, logos, and cuts. 3D relief engraving modulates laser power or speed according to a grayscale depth map, creating sculptural surfaces on wood, stone, and acrylic — a single image file generates full three-dimensional relief without multi-axis toolpaths.</div>
    </div>
  );
}

// ── Diagram 6: Process Parameters Interaction ──────────────────────
function DiagramProcessParameters() {
  const W = 960, H = 400;

  // Left: parameter→output influence matrix
  // Right: power vs speed operating window chart

  const cL = 520, cR = 930, cT = 50, cB = 350;
  const cW = cR - cL, cH = cB - cT;

  // Operating window: speed 0–1000 mm/s, power 0–100%
  // Regions: underburn (low power), optimal, overburn (high power / low speed), through-cut
  const sx = v => cL + (v / 1000) * cW;
  const py2 = v => cB - (v / 100) * cH;

  const inputs = [
    { label: 'Power (%)', desc: 'Energy per unit time delivered\nto the material surface' },
    { label: 'Speed (mm/s)', desc: 'Laser head traverse velocity;\naffects energy density per mm²' },
    { label: 'Frequency (Hz)', desc: 'Pulse repetition rate for\npulsed lasers (50–100 kHz)' },
    { label: 'Passes', desc: 'Number of complete scans;\ndepth ∝ passes × single-pass depth' },
    { label: 'Focus offset', desc: 'Distance from nominal focal plane;\npositive = defocused (wider kerf)' },
  ];

  const outputs = [
    { label: 'Engraving depth', col: '#1e7a36' },
    { label: 'Surface Ra (roughness)', col: '#e07b00' },
    { label: 'Edge quality', col: '#1565c0' },
    { label: 'HAZ width', col: '#c0392b' },
    { label: 'Throughput (speed)', col: '#546e7a' },
  ];

  // Influence matrix [input][output]: +2 strong increase, +1 moderate, 0 none, -1 decrease
  const influence = [
    [+2, +1, +1, +2, 0],   // Power
    [-1, -1, -1, -1, +2],  // Speed
    [+1, +1,  0, -1, 0],   // Frequency
    [+2, 0,   0, +1, -1],  // Passes
    [-1, +1, -2, +1, 0],   // Focus offset
  ];

  const infLabels = ['−−','−','0','+','++'];
  const infColors = ['#c0392b','#e07b00','#b6dfc0','#52b96a','#1e7a36'];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Process Parameter Interactions &amp; Operating Window (Wood / Acrylic)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="ppArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#333"/>
          </marker>
        </defs>

        {/* ── LEFT: Influence matrix ── */}
        {/* Header row */}
        <rect x={0} y={0} width={510} height={50} fill="#1e7a36"/>
        <text x={128} y={20} textAnchor="middle" fontSize="10" fill="#fff" fontWeight="700">Input Parameter</text>
        {outputs.map(({ label }, oi) => (
          <text key={oi} x={258 + oi * 50} y={20} textAnchor="middle" fontSize="8"
                fill="#fff" fontWeight="700"
                transform={`rotate(-35 ${258+oi*50} 20)`}>{label}</text>
        ))}
        <text x={258 + 5*50/2} y={44} textAnchor="middle" fontSize="9" fill="#c6efce">Output →</text>

        {inputs.map(({ label, desc }, ii) => {
          const ry = 50 + ii * 62;
          return (
            <g key={ii}>
              <rect x={0} y={ry} width={510} height={60} fill={ii%2===0?'#edf7f0':'#fff'} stroke="#b6dfc0" strokeWidth="0.5"/>
              {/* Input name and desc */}
              <text x={8} y={ry + 18} fontSize="11" fill="#145a24" fontWeight="700">{label}</text>
              {desc.split('\n').map((line, li) => (
                <text key={li} x={8} y={ry + 32 + li * 13} fontSize="9" fill="#546e7a">{line}</text>
              ))}
              {/* Influence cells */}
              {influence[ii].map((inf, oi) => {
                const cellX = 250 + oi * 50;
                const normInf = inf + 2;   // 0–4 index
                const bgCol = infColors[normInf];
                return (
                  <g key={oi}>
                    <rect x={cellX} y={ry + 10} width={44} height={40} rx={3}
                          fill={bgCol} opacity="0.25" stroke={bgCol} strokeWidth="1"/>
                    <text x={cellX + 22} y={ry + 34} textAnchor="middle" fontSize="12"
                          fill={bgCol} fontWeight="700">{infLabels[normInf]}</text>
                  </g>
                );
              })}
            </g>
          );
        })}

        {/* ── RIGHT: Power vs Speed operating window ── */}
        <rect x={cL} y={cT} width={cW} height={cH} rx={3} fill="#f4fbf6" stroke="#b6dfc0"/>

        {/* Operating zones */}
        {/* Under-burn zone: low power */}
        <path d={`M ${cL},${cT} L ${cR},${cT} L ${cR},${py2(20)} Q ${sx(600)},${py2(10)} ${cL},${py2(5)} Z`}
              fill="#546e7a" opacity="0.12"/>
        <text x={cL + cW*0.5} y={cT + 16} textAnchor="middle" fontSize="9" fill="#546e7a" fontWeight="700">UNDERBURN (insufficient energy)</text>

        {/* Over-burn zone: high power, low speed */}
        <path d={`M ${cL},${py2(80)} Q ${sx(200)},${py2(70)} ${sx(400)},${py2(55)} L ${cL},${cB} Z`}
              fill="#c0392b" opacity="0.10"/>
        <text x={cL + 50} y={cB - 20} fontSize="9" fill="#c0392b" fontWeight="700">OVERBURN</text>
        <text x={cL + 50} y={cB - 8} fontSize="8.5" fill="#c0392b">(char / fire risk)</text>

        {/* Through-cut zone: very high energy */}
        <path d={`M ${sx(100)},${cB} L ${sx(100)},${py2(95)} Q ${sx(400)},${py2(82)} ${cR},${py2(80)} L ${cR},${cB} Z`}
              fill="#e07b00" opacity="0.13"/>
        <text x={sx(200)} y={py2(88)} textAnchor="middle" fontSize="9" fill="#e07b00" fontWeight="700">THROUGH-CUT ZONE</text>

        {/* Optimal operating window */}
        <path d={`M ${sx(200)},${py2(30)} Q ${sx(400)},${py2(55)} ${sx(800)},${py2(75)} L ${cR},${py2(70)} Q ${cR},${py2(25)} ${sx(700)},${py2(20)} Q ${sx(400)},${py2(15)} ${sx(200)},${py2(30)} Z`}
              fill="#1e7a36" opacity="0.15"/>
        <text x={sx(550)} y={py2(45)} textAnchor="middle" fontSize="10" fill="#1e7a36" fontWeight="700">OPTIMAL</text>
        <text x={sx(550)} y={py2(33)} textAnchor="middle" fontSize="9" fill="#1e7a36">WINDOW</text>

        {/* Grid lines */}
        {[200,400,600,800].map(v => (
          <line key={v} x1={sx(v)} y1={cT} x2={sx(v)} y2={cB}
                stroke="#b6dfc0" strokeWidth="1" strokeDasharray="3,3"/>
        ))}
        {[20,40,60,80].map(v => (
          <g key={v}>
            <line x1={cL} y1={py2(v)} x2={cR} y2={py2(v)} stroke="#b6dfc0" strokeWidth="1" strokeDasharray="3,3"/>
            <text x={cL - 4} y={py2(v) + 4} textAnchor="end" fontSize="9" fill="#555">{v}</text>
          </g>
        ))}

        {/* Axes */}
        <line x1={cL} y1={cB} x2={cR + 8} y2={cB} stroke="#333" strokeWidth="1.5" markerEnd="url(#ppArr)"/>
        <line x1={cL} y1={cB} x2={cL} y2={cT - 8} stroke="#333" strokeWidth="1.5" markerEnd="url(#ppArr)"/>
        {[0,200,400,600,800,1000].map(v => (
          <text key={v} x={sx(v)} y={cB + 14} textAnchor="middle" fontSize="9" fill="#555">{v}</text>
        ))}
        <text x={cL + cW/2} y={cB + 28} textAnchor="middle" fontSize="11" fill="#333">Speed (mm/s) →</text>
        <text x={cL - 34} y={cT + cH/2} textAnchor="middle" fontSize="11" fill="#333"
              transform={`rotate(-90 ${cL-34} ${cT+cH/2})`}>Power (%) →</text>
        <text x={cL + cW/2} y={cT - 8} textAnchor="middle" fontSize="11" fill="#145a24" fontWeight="700">
          Power vs Speed Operating Window
        </text>
      </svg>
      <div style={S.dCaption}>The parameter influence matrix shows how each input variable affects key outputs (++ = strong increase, −− = strong decrease). Power and speed have the strongest and most opposite effects on engraving depth and throughput. The operating window chart shows the power–speed combinations that produce clean engraving: insufficient energy yields under-burn; excessive energy per unit area causes char, fire risk, or through-cutting. Each material requires empirical characterisation to map its specific window.</div>
    </div>
  );
}

// ── Diagram 7: Material Suitability Matrix ─────────────────────────
function DiagramMaterialMatrix() {
  const W = 960, H = 380;

  const materials = [
    'Wood (soft)',
    'Wood (hard)',
    'Acrylic (cast)',
    'MDF / plywood',
    'Leather',
    'Anodised Al',
    'Bare steel',
    'Glass / ceramic',
    'Fabric / denim',
    'Rubber / silicone',
  ];

  const laserCols = [
    { name:'CO₂\n10.6 µm', col:'#c0392b' },
    { name:'Fiber\n1.06 µm', col:'#1565c0' },
    { name:'Diode\n~450 nm', col:'#6a1b9a' },
    { name:'Nd:YAG UV\n355 nm', col:'#1e7a36' },
  ];

  // Ratings: 3=Excellent, 2=Good, 1=Marginal, 0=Not suitable
  const matrix = [
    [3, 0, 2, 1],  // Wood soft
    [3, 0, 2, 1],  // Wood hard
    [3, 0, 1, 2],  // Acrylic cast
    [3, 0, 2, 1],  // MDF/plywood
    [3, 1, 2, 1],  // Leather
    [1, 3, 2, 2],  // Anodised Al
    [0, 3, 1, 2],  // Bare steel
    [2, 1, 0, 3],  // Glass/ceramic
    [3, 0, 2, 1],  // Fabric
    [2, 0, 2, 2],  // Rubber
  ];

  const ratingColors = ['#fde8e8','#fff3cd','#d4edda','#c6efce'];
  const ratingLabels = ['✗ None','~ Marg.','✓ Good','★ Excel'];
  const ratingTextCol= ['#c0392b','#8b5c00','#1e7a36','#145a24'];

  const nameColW = 170;
  const cellW = (W - nameColW - 20) / laserCols.length;
  const headerH = 70;
  const cellH = (H - headerH - 30) / materials.length;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Material Suitability Matrix — Laser Type vs Work Material</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Header */}
        <rect x={0} y={0} width={W} height={headerH} fill="#1e7a36"/>
        <text x={nameColW/2} y={headerH/2+6} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">Material</text>
        {laserCols.map(({ name, col }, li) => {
          const hx = nameColW + 10 + li * cellW + cellW/2;
          return (
            <g key={li}>
              <rect x={nameColW + 10 + li * cellW + 4} y={4} width={cellW - 8} height={headerH - 8}
                    rx={3} fill={col} opacity="0.3"/>
              {name.split('\n').map((line, i) => (
                <text key={i} x={hx} y={28 + i * 18} textAnchor="middle"
                      fontSize="11" fill="#fff" fontWeight="700">{line}</text>
              ))}
            </g>
          );
        })}

        {/* Data rows */}
        {materials.map((mat, mi) => {
          const ry = headerH + mi * cellH;
          return (
            <g key={mi}>
              <rect x={0} y={ry} width={W} height={cellH} fill={mi%2===0?'#f4fbf6':'#fff'} stroke="#b6dfc0" strokeWidth="0.5"/>
              <text x={8} y={ry + cellH/2 + 4} fontSize="11" fill="#145a24" fontWeight="600">{mat}</text>
              {matrix[mi].map((rating, li) => {
                const cx2 = nameColW + 10 + li * cellW + cellW/2;
                const cy2 = ry + cellH/2;
                return (
                  <g key={li}>
                    <rect x={nameColW + 10 + li * cellW + 4} y={ry + 3} width={cellW - 8} height={cellH - 6}
                          rx={3} fill={ratingColors[rating]} stroke="#b6dfc0" strokeWidth="0.8"/>
                    <text x={cx2} y={cy2 + 4} textAnchor="middle" fontSize="10"
                          fill={ratingTextCol[rating]} fontWeight="700">
                      {ratingLabels[rating]}
                    </text>
                  </g>
                );
              })}
            </g>
          );
        })}

        {/* Legend */}
        {ratingLabels.map((rl, ri) => (
          <g key={ri}>
            <rect x={nameColW + 10 + ri * 160} y={headerH + materials.length * cellH + 6}
                  width={50} height={16} rx={3} fill={ratingColors[ri]} stroke="#b6dfc0" strokeWidth="0.8"/>
            <text x={nameColW + 64 + ri * 160} y={headerH + materials.length * cellH + 18}
                  fontSize="10" fill={ratingTextCol[ri]} fontWeight="700">{rl}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>Material suitability is governed primarily by the match between laser wavelength and material absorption coefficient at that wavelength. CO₂ (10.6 µm) is absorbed by virtually all organic materials and glass but reflected by bare metals. Fiber (1.06 µm) is ideal for metals and dark polymers. UV Nd:YAG (355 nm) enables cold ablation on brittle and transparent materials. Always verify with a test piece — grades vary by supplier, surface treatment, and colourant (e.g. black acrylic vs clear acrylic differ significantly).</div>
    </div>
  );
}

// ── Main export ────────────────────────────────────────────────────
export default function LaserEngraving() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Laser Engraving — Industrial Engineering</h1>
      <p style={S.p}>
        Laser engraving is a non-contact subtractive manufacturing process in which a focused laser beam ablates, vaporises, or chemically alters material surfaces to produce permanent markings, textures, and three-dimensional relief features. It is used across industries from product identification and traceability marking to decorative consumer goods, medical device coding, and microelectronics patterning. Understanding laser–material interaction physics, system geometry, parameter optimisation, and safety requirements is essential for industrial application.
      </p>

      <InfoBox title="Core Concepts at a Glance" items={[
        "Laser engraving uses focused light energy to ablate, vaporise, or chemically alter material surfaces — non-contact, no tooling, no forces on workpiece",
        "Four main laser types: CO₂ (10.6 µm, organics), Fiber (1.06 µm, metals), Diode (~450 nm, affordable), UV Nd:YAG (355 nm, precision/cold ablation)",
        "Key parameters: power (%), speed (mm/s), frequency (Hz), passes, focus offset, line spacing (DPI)",
        "Energy density (fluence) = Power / (Speed × Spot area) [J/cm²] — governs depth and quality",
        "Spot size w₀ = (λ × f) / (π × r_beam) — smaller spot = higher power density = finer detail",
        "Rayleigh range z_R = π × w₀² / λ — longer z_R = greater depth of focus for 3D objects",
        "HAZ (heat-affected zone): thermal alteration beyond ablation zone — minimised by pulsed / ultrashort pulse lasers",
        "Three engraving modes: raster (area fills/images), vector (outlines/cuts), 3D relief (grayscale depth mapping)",
        "Safety: Class 4 laser hazard — mandatory enclosure, interlocks, fume extraction, PPE (laser safety eyewear)",
      ]}/>

      <h2 style={S.h2}>Machine Anatomy &amp; System Components</h2>
      <p style={S.p}>
        Industrial laser engravers consist of a laser source, beam delivery optics, a motion system, a work surface, and ancillary systems for fume extraction and air assist. The laser source generates the coherent light; mirrors and lenses deliver and focus it; the motion system positions the focal point relative to the workpiece; the exhaust system removes hazardous vapours generated during ablation.
      </p>
      <DiagramMachineAnatomy/>
      <Table2 rows={[
        ["Laser source types","CO₂ tube: glass or metal RF-excited; typical life 2,000–10,000 hours\nFiber laser: active Yb-doped fiber; life >50,000 hours; no alignment needed\nDiode module: laser diode array; life >10,000 hours; lowest cost"],
        ["Gantry vs galvo systems","Gantry: stepper/servo motors move X–Y frame carrying mirrors\nSpeed: 100–1,000 mm/s; area: 300×200 mm to 1,300×900 mm\nGalvo: two fast mirror scanners; speeds up to 10,000 mm/s\nGalvo used for high-speed marking and metal engraving (fiber laser)"],
        ["Focusing lens","Plano-convex or F-theta (flat-field) lens; focal lengths 38–300 mm\nShorter focal length → smaller spot → finer detail; less depth of focus\nF-theta lens corrects field curvature — essential for galvo systems"],
        ["Air assist","Pressurised air (0.5–5 bar) jets at cutting point; removes debris\nPrevents flame and smoke re-deposit; cools workpiece\nOptional: N₂ assist for metals (prevents oxidation); O₂ for cutting speed"],
        ["Honeycomb bed","Open lattice table minimises back-reflection into workpiece\nAllows downward cutting without charring the support surface\nAluminium or stainless steel; replaceable when contaminated"],
        ["Fume extraction","Mandatory for all materials; CO₂ output contains CO, VOCs, particulate\nActive carbon + HEPA filtration for most applications\nSpecialised filters for PVC (toxic HCl), acrylic (MMA), metals (fine particles)"],
        ["Autofocus systems","Capacitive or laser distance sensor measures workpiece height\nAdjusts Z-axis to maintain focal plane on uneven or curved surfaces\nAccuracy ±0.1–0.5 mm; essential for 3D engraving schedules"],
      ]}/>

      <h2 style={S.h2}>Laser–Material Interaction &amp; Ablation Physics</h2>
      <p style={S.p}>
        When a focused laser beam strikes a surface, the material response depends on the absorbed power density (irradiance) and the material's optical, thermal, and mechanical properties. Below the ablation threshold, the laser only heats the material. Above it, rapid vaporisation occurs, creating a crater surrounded by a heat-affected zone (HAZ).
      </p>
      <DiagramLaserMaterialInteraction/>
      <Table2 rows={[
        ["Ablation threshold","Minimum fluence required to initiate material removal [J/cm²]\nWood: ~0.5–2 J/cm²; metals: ~0.1–1 J/cm²; glass: ~5–20 J/cm²\nBelow threshold: heating only — can cause scorching without removal"],
        ["Laser fluence (energy density)","H = P / (v × d_spot)  [J/cm²]  where P=power, v=speed, d_spot=spot diameter\nHigher fluence → deeper ablation per pass\nExcessive fluence → wide HAZ, charring, re-solidified layer"],
        ["Thermal diffusion length","L_thermal = √(κ × τ_pulse)  where κ=thermal diffusivity, τ=pulse duration\nShort pulses → small L_thermal → small HAZ\nUltrashort pulses (fs–ps): L_thermal < ablation depth → cold ablation"],
        ["Continuous wave vs pulsed","CW (continuous wave): constant beam; high average power; large HAZ\nPulsed: burst of energy followed by cooling period; smaller HAZ per joule\nQ-switched (ns pulses): 10⁸–10¹⁰ W/cm² peak irradiance"],
        ["Re-cast / re-solidified layer","Melt that re-solidifies inside the crater walls\nCan be amorphous, porous, or chemically altered\nAffects adhesion, corrosion resistance; remove by post-process abrasion or etching"],
        ["Plasma shielding","At very high irradiance, ionised vapour (plasma) forms above surface\nPlasma can absorb/scatter the incoming beam — reduces effective fluence\nManage by reducing power, increasing speed, or using off-axis gas jets"],
        ["Colour change marking (MOPA fiber)","Some materials (stainless steel, titanium) produce oxide colour layers at low power/high frequency\nNo material removal — surface oxidation only; no depth\nUsed for decorative colour marking on jewellery, medical devices"],
      ]}/>

      <h2 style={S.h2}>Laser Types &amp; Wavelength Selection</h2>
      <p style={S.p}>
        Laser wavelength determines which materials can be processed and the achievable spot size. The critical selection rule is: the material must absorb the laser wavelength efficiently. A CO₂ beam passes through clear acrylic without engraving it (it's absorbed at the surface of cast acrylic but transmits through some grades); a fiber beam passes through wood almost entirely.
      </p>
      <DiagramLaserTypes/>
      <Table2 rows={[
        ["CO₂ laser (10.6 µm)","Glass tube (RF-excited preferred for higher rep rate); 10–400 W\nAbsorbed by all organic materials, glass, rubber; reflected by polished metals\nMost widely used for wood, acrylic, leather, fabric, paper, MDF\nReplacement tube cost: $50–500 depending on power and brand"],
        ["Fiber laser (1.06 µm)","Ytterbium-doped double-clad fiber; diode-pumped; very high brightness\nAbsorbed by metals and dark polymers; penetrates wood and light plastics\nLife: >50,000 hours; no beam alignment needed; excellent beam quality M² ~1.05\nDominant for metal marking, annealing, deep engraving of steel"],
        ["Diode laser (445–980 nm)","Semiconductor junction laser array; most affordable technology\nGood absorption on dark/coloured materials, wood, leather, cork\nLimited power density vs CO₂/fiber; slower for deep engraving\nRapidly improving; 30 W diode machines now compete with 40 W CO₂"],
        ["Nd:YAG (1064 nm) and frequency-doubled (532 nm / 355 nm UV)","Crystal or DPSS (diode-pumped solid-state) laser\nUV (355 nm) enables photochemical ablation: minimal thermal damage\nUsed for PCBs, silicon wafers, glass, sapphire, medical devices\nHighest resolution — spot sizes as small as 10–20 µm achievable"],
        ["Ultrashort pulse (ps / fs)","Pulse durations < 1 ns: no thermal diffusion during pulse\nCold ablation — no HAZ, no re-cast; precise, clean edges\nApplications: precision micro-engraving, stents, optical components\nHigh capital cost (> $100k); limited to specialist applications"],
        ["MOPA fiber laser","Master Oscillator Power Amplifier: adjustable pulse width (1–500 ns) and frequency\nEnables colour marking on stainless steel by controlling oxide thickness\nMore flexible than standard Q-switched fiber; preferred for mixed applications\nMarkings are corrosion and UV stable — used for medical device UDI coding"],
      ]}/>

      <h2 style={S.h2}>Beam Profile &amp; Focal Geometry</h2>
      <p style={S.p}>
        The spatial distribution of laser energy across the beam cross-section (the beam profile) determines the achievable spot size, power density, and depth of focus. Most laser engravers operate in the TEM₀₀ (fundamental transverse electromagnetic) mode, which produces a Gaussian intensity distribution — maximum intensity at the beam centre, falling to 1/e² at the beam radius.
      </p>
      <DiagramBeamProfile/>
      <Table2 rows={[
        ["Gaussian beam (TEM₀₀)","Intensity I(r) = I₀ × exp(−2r²/w²)  [I₀ = peak intensity, w = beam radius at 1/e²]\nMost common mode; best focusability; M² = 1 (ideal)\nPeak power density at centre: I₀ = 2P/(π × w²)  [W/cm²]"],
        ["M² beam quality factor","M² = 1 for ideal Gaussian; >1 for real beams (spatial coherence degradation)\nw₀(real) = M² × w₀(ideal)  — larger M² → larger minimum spot\nCO₂ glass tube: M² ~1.2–1.5; fiber: M² ~1.05–1.1; diode: M² ~1.5–3.0"],
        ["Focal length selection","Short FL (38–63 mm): small spot (0.05–0.1 mm), short depth of focus\nMedium FL (100 mm): balanced spot/depth — most common for engraving\nLong FL (200–300 mm): larger spot, long depth of focus — for 3D/curved objects"],
        ["Depth of focus (DOF)","DOF ≈ 2 × z_R = 2πw₀²/λ  — range over which spot area stays within 2×\nCO₂ at w₀=0.1 mm: z_R ≈ 3 mm;  fiber at w₀=0.03 mm: z_R ≈ 2.7 mm\nFor workpieces taller than ±z_R, dynamic autofocus or segmented Z-steps needed"],
        ["Defocus effects","Positive defocus (+z): spot above surface → wider, shallower mark\nNegative defocus (−z): spot below surface → similar widening\nDeliberate defocus: used to increase kerf width or reduce power density"],
        ["Spot size and resolution","Minimum feature size ≈ spot diameter × 1.5 (overlap factor)\nCO₂ at F=100 mm: spot ~0.2 mm → minimum feature ~0.3 mm\nFiber at F=100 mm: spot ~0.06 mm → minimum feature ~0.09 mm"],
      ]}/>

      <h2 style={S.h2}>Engraving Modes &amp; File Formats</h2>
      <p style={S.p}>
        The choice of engraving mode — raster, vector, or 3D relief — is determined by the design intent and material behaviour. Most industrial laser controllers accept both raster (bitmap) and vector (SVG, DXF) input, automatically optimising paths for each mode. Understanding the tradeoffs between modes is essential for maximising quality and throughput.
      </p>
      <DiagramEngravingModes/>
      <Table2 rows={[
        ["Raster mode (bitmap)","Laser scans line by line like an inkjet; density set by DPI (lines per inch)\n300 DPI: line spacing 0.085 mm; 600 DPI: 0.042 mm\nTime ∝ engraved area × DPI²; suitable for photos, filled logos, textures"],
        ["Vector mode (path)","Laser follows exact path of lines, curves, text outlines\nSpeed-controlled: slow = deep, fast = shallow outline\nFile formats: DXF, SVG, AI, PLT — direct path import\nNo fill → faster than raster for outline-only designs"],
        ["3D relief mode","Grayscale image (PNG/TIFF, 8-bit): white=0% power, black=100%\nDepth calibration curve (power vs depth) must be measured per material\nMultiple passes at different DPI/power settings can blend depth gradients"],
        ["Combined jobs","Production jobs often combine modes: vector outline + raster fill\nRaster first, then vector cuts (prevents movement of cut pieces during rastering)\nMulti-layer jobs processed by Z-level: surface marking → deep engraving → cut"],
        ["File preparation","Vector: ensure closed paths, merged overlapping curves, correct line weights\nRaster: convert to grayscale; adjust gamma for material (usually increase contrast)\nDPI selection: 300 DPI for wood grain (lower for textured surface); 600+ DPI for fine detail"],
        ["Kerf compensation","Vector paths are centred on the beam spot — kerf width = spot diameter\nFor precision fits: offset path inward (female part) or outward (male part) by kerf/2\nKerf varies with speed, power, material — measure empirically for each job type"],
        ["LPI vs DPI","LPI (lines per inch): raster scan line density\nDPI (dots per inch): synonymous in most software but technically distinct\n150–300 LPI for wood (matching grain texture); 500–1000 LPI for acrylic (smoother)"],
      ]}/>

      <h2 style={S.h2}>Process Parameter Optimisation</h2>
      <p style={S.p}>
        Laser engraving parameters must be empirically optimised for each laser–material combination. No single set of parameters works across materials. Industrial users maintain material libraries with tested settings; for new materials, systematic parameter sweeps identify the optimal operating window.
      </p>
      <DiagramProcessParameters/>
      <Table2 rows={[
        ["Power vs speed trade-off","Energy density H = P / (v × d_spot) — any combination giving the same H produces similar depth\nLow power + low speed vs high power + high speed: different HAZ despite same H\nHigh power + high speed: preferred — less dwell time per point → smaller HAZ"],
        ["Frequency (PRR)","Pulse repetition rate: typically 1–100 kHz for CO₂; up to 1 MHz for fiber\nAt high speed, low frequency: individual pulses visible as dotted lines (scalloping)\nRule: overlap ratio = 1 − (speed / (frequency × spot_size)) — keep above 70% for smooth lines"],
        ["Number of passes","Each pass removes one layer; total depth ≈ single-pass depth × passes\nInter-pass cooling (pause or reduce power) reduces HAZ accumulation\nMulti-pass at lower power: better for deep engraving; single-pass: faster but more HAZ"],
        ["Focus position","Surface focus: deepest engraving for a given power\nSlightly positive defocus: wider, shallower, smoother texture on wood\nNegative defocus: similar but beam has already converged — different edge profile"],
        ["Line spacing / step-over","DPI governs line spacing: 100 DPI = 0.254 mm, 600 DPI = 0.042 mm\nFor smooth fills: overlap adjacent lines by 50–70% (step-over = spot_size × 0.3–0.5)\nWider spacing = faster but visible lines; narrower = smoother but slower"],
        ["Parameter testing protocol","1. Power sweep at fixed speed: find ablation threshold and char point\n2. Speed sweep at fixed power: find optimal speed band\n3. Pass count: determine depth-per-pass calibration curve\n4. DPI sweep: select minimum DPI giving acceptable fill quality"],
        ["Material-specific considerations","Wood: moisture content affects depth; grain direction changes texture\nAcrylic: cast = clearer engraving; extruded = frosted; always test brand\nLeather: vegetable-tanned best; chromium-tanned releases toxic Cr(VI) — ventilate"],
      ]}/>

      <h2 style={S.h2}>Material Suitability &amp; Processing Guidelines</h2>
      <DiagramMaterialMatrix/>
      <Table2 rows={[
        ["Wood & wood composites","CO₂ at 40–80% power, 200–500 mm/s, 300 DPI for raster\nMDF: higher power needed (dense resin); acrid fumes — heavy ventilation\nPlywood: test each layer — glue layers may char more than wood fibres\nSoftwood vs hardwood: hardwood needs more power or slower speed"],
        ["Acrylic (PMMA)","Cast acrylic engraves frosted white — excellent contrast\nExtruded acrylic: lower quality engrave; tends to melt rather than ablate cleanly\nCO₂ optimum: 300 mm/s, 50–70% power (40 W machine) for 0.5 mm depth\nNever engrave PVC with CO₂ — releases toxic HCl; test unknown plastics first"],
        ["Metals — CO₂","CO₂ does not engrave bare metals; use metal-marking compound (CerMark, Dry Moly)\nCompound painted on, laser fuses it to surface; excess wiped off\nAlternatively: anodised aluminium — CO₂ ablates anodising to reveal base metal"],
        ["Metals — Fiber / MOPA","Direct metal engraving: stainless steel, aluminium, titanium, brass, copper\nDeep engraving: 10–80 W, 200–500 mm/s, multiple passes\nColour marking (MOPA): 0.5–3 W, 1000+ mm/s, 70–100 kHz for oxide colours\nBare copper: highly reflective — use higher frequency to reduce pulse energy spike"],
        ["Glass & ceramics","CO₂: surface frosting (micro-fracture) — not ablation; crack risk on thin glass\nUV Nd:YAG: clean ablation with minimal fracture; preferred for precise glass work\nTechnique: engrave on reverse side of glass for 'sub-surface' look effect\nCeramic tile: CO₂ at high power fuses surface into smooth glazed mark"],
        ["Leather","CO₂: excellent; vegetable-tanned produces crisp burn marks\nChromium-tanned leather releases Cr(VI) — known carcinogen; avoid or heavy LEV\nSpeed 400–600 mm/s, power 25–40%, multiple passes for deep relief\nFaux leather (PU-coated): check for PVC content before processing"],
        ["NEVER engrave","PVC / vinyl: releases HCl gas — toxic, corrosive to machine\nPolycarbonate: toxic smoke; CO₂ tends to leave rough edges\nBeryllium copper: toxic BeO fumes — fatal risk\nCarbon fibre (CFRP): toxic carbon fibre particles — specialised extraction needed\nFoam with unknown content: may contain toxic blowing agents"],
      ]}/>

      <h2 style={S.h2}>Quality Control &amp; Inspection</h2>
      <Table2 rows={[
        ["Depth measurement","Tactile profilometer (stylus) — ISO 4287; Zygo white light interferometer for micro-features\nCross-section SEM for characterising HAZ and re-cast layers in metals\nSimple: measure with calibrated focus dial (Δfocus = Δdepth in focusing range)"],
        ["Edge quality assessment","Visual inspection under raking light or digital microscope (50–200×)\nCharring index: proprietary scales for wood; measure reflectance change\nMetal edge roughness: Ra measurement by stylus or confocal microscope"],
        ["Dimensional accuracy","Calibrate X–Y scale with known reference artefact (e.g. calibrated grid)\nMeasure with calibrated vernier, CMM, or optical comparator\nTypical accuracy: ±0.1 mm gantry; ±0.05 mm servo; ±0.02 mm galvo with correction"],
        ["Contrast / mark quality","Optical density measurement for dark marks on light substrates (spectrophotometer)\nPermanence tests: ISO 1043 adhesion tape test; UV exposure; solvent wipe\nCode readability: 1D barcode: ISO 15416; 2D (QR/DataMatrix): ISO 15415"],
        ["Process monitoring","Inline camera systems detect mis-engravings, debris, pattern shift\nPyrometer or IR camera monitors surface temperature — burn prevention\nPower meter inline: laser output power vs programmed — calibration check"],
        ["Repeatability testing","Engrave 10 identical parts; measure depth, width, position\nCalculate Cp, Cpk per ISO 22514 — target Cpk ≥ 1.33 for safety-critical marks\nRe-calibrate X–Y when positional Cpk drops below 1.67"],
      ]}/>

      <h2 style={S.h2}>Safety &amp; Regulatory Requirements</h2>
      <Table2 rows={[
        ["Laser safety classification","Class 4: most industrial engravers; accessible beam can cause immediate eye/skin injury\nMachine must be fully enclosed with safety interlocks — EN 60825-1 / IEC 60825-1\nAdequate laser safety eyewear (OD rated for specific wavelength) in enclosure-open mode"],
        ["Enclosure & interlock requirements","All access doors must have magnetic/key interlocks cutting laser power when opened\nViewing windows: laser-blocking OD≥5 for CO₂; OD≥7 for fiber (1064 nm much more hazardous to eyes)\nWarning lights and audible alarm during operation — EN ISO 11553"],
        ["Fume extraction — mandatory","Laser fumes contain CO, VOCs, ultrafine particles, heavy metals (from coated materials)\nExtraction flow rate: minimum 100–200 m³/h per kW of laser power\nActive carbon + HEPA H14 filtration; check filter saturation — replace on schedule\nNever engrave without running extraction — COSHH / OSHA obligation"],
        ["Electrical & fire safety","High voltage (10–30 kV) in CO₂ tube power supply — qualified technician only\nFire risk: keep flammable materials away; never leave running unattended\nFire suppression system in spray booth / large industrial cells recommended\nEarth bonding: machine frame and workpiece holder to building earth"],
        ["CE / UL marking","Industrial machines require CE marking (EU) or UL certification (US)\nLaser safety officer (LSO) required by ANSI Z136.1 in US for Class 3B/4 installations\nRisk assessment and SOP required for every new material processed"],
        ["Regulatory marking standards","ISO 11784/5: RFID transponder (laser marked for animal ID)\nUDI (Unique Device Identification) FDA 21 CFR Part 830: laser marked on medical devices\nGS1 DataMatrix on pharmaceuticals: ISO 15415 grade A minimum for track-and-trace"],
      ]}/>

      <InfoBox title="Key Formulae &amp; Reference Values" items={[
        "Beam waist: w₀ = (M² × λ × f) / (π × r_input)   [λ = wavelength, f = focal length, r_input = input beam radius]",
        "Rayleigh range: z_R = π × w₀² / (M² × λ)   [depth over which spot area stays within 2× minimum]",
        "Peak irradiance: I₀ = 2P / (π × w₀²)   [W/cm²] — must exceed ablation threshold",
        "Fluence (energy density): H = P / (v × d_spot)   [J/cm²]   where v = speed, d_spot = spot diameter",
        "Overlap ratio: η = 1 − (v / (f_rep × 2w₀))   [keep η > 0.7 for smooth lines]",
        "Theoretical depth per pass: d ≈ (1/α) × ln(H / H_th)   [α = absorption coefficient, H_th = threshold fluence]",
        "Thermal diffusion length: L = √(2κτ)   [κ = thermal diffusivity mm²/s, τ = pulse duration]",
        "DPI to line spacing: Δy (mm) = 25.4 / DPI   [e.g. 600 DPI → 0.042 mm line spacing]",
        "Scan speed for consistent overlap at frequency f: v_max = f × 2w₀ × (1 − η)",
        "Focusing lens f-number: f/# = f / (2 × r_input)   [lower f/# → smaller spot → more precise engraving]",
      ]}/>
    </div>
  );
}